import React from 'react'

import { Route, Redirect } from 'react-router-dom';
import Navigation from 'scripts/components/Navigation'
import MediaCampaign from './campaign'
import Media from './index';
import MediaDop from './declaration-of-performance';
import MediaHighResolution from './high-resolution';
import MediaManuals from './manuals';
import MediaSigns from './signs';
import MediaVideo from './video';

export default function NewConstruction({ baseName, newConstruction }) {
    return (
        <div
            className={`page-content page-content-${baseName}`}
        >
            <div className="main-container">





                <Route
                    path="/new-construction/media"
                    render={(props) => <Media {...props} market={'sv-NewConstruction'} />}
                />
                <Route
                    path="/new-construction/media-dop"
                    render={(props) => <MediaDop {...props} market={'sv-SE'} />}
                />
                <Route
                    path="/new-construction/media-high-resolution"
                    render={(props) => <MediaHighResolution {...props} market={'sv-NewConstruction'} />}
                />
                <Route
                    path="/new-construction/media-manuals"
                    render={(props) => <MediaManuals {...props} market={'sv-SE'} />}
                />
                <Route
                    path="/new-construction/media-signs"
                    render={(props) => <MediaSigns {...props} market={'sv-NewConstruction'} />}
                />
                <Route
                    path="/new-construction/media-video"
                    render={(props) => <MediaVideo {...props} market={'sv-SE'} />}
                />
                <Route
                    path="/new-construction"
                    render={() => <Redirect to="/new-construction/media" />}
                />



            </div>
            <Navigation baseName={'new-construction'} newConstruction={newConstruction} unauthenticated={false} />
        </div>
    )
}
